export enum PaginationSortField {
  Distance = 'distance',
  Salary = 'salary_high',
  Score = 'score',
  PpiScore = 'ppiScore',
  PpiBadge = 'ppiBadge',
}
